var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "presential",
              label: _vm.$t("presential"),
              icon: "fal fa-graduation-cap"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "presential" }
            },
            [
              _c(
                "div",
                [
                  _vm.$q.platform.is.desktop
                    ? _c("div", { staticClass: "row gutter-sm" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-11" },
                          [
                            _c("p", { staticClass: "q-title" }, [
                              _vm._v(_vm._s(_vm.title))
                            ]),
                            _c(
                              "p",
                              { staticClass: "q-body-1 text-weight-light" },
                              [_vm._v(_vm._s(_vm.description))]
                            ),
                            _c(
                              "p",
                              { staticClass: "q-body-1 text-weight-light" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("timezone") +
                                      ": " +
                                      _vm.getHumanTimezone(_vm.timezone)
                                  )
                                )
                              ]
                            ),
                            _c(
                              "p",
                              { staticClass: "q-my-xs text-weight-bold" },
                              [_vm._v(_vm._s(_vm.$t("instructors")))]
                            ),
                            _vm._l(_vm.instructors_list, function(
                              instructor,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index, staticClass: "q-my-sm" },
                                [
                                  _c("p", { staticClass: "q-my-xs" }, [
                                    _vm._v(_vm._s(instructor))
                                  ])
                                ]
                              )
                            }),
                            _c("q-btn", {
                              attrs: {
                                color: _vm.getSubscribeButtonColor,
                                label: _vm.$t(_vm.getSubscribeButtonLabel),
                                icon: _vm.getSubscribeButtonIcon
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showSubscription()
                                }
                              }
                            })
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-sm-1 cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.showCertificate()
                              }
                            }
                          },
                          [
                            _c(
                              "vc-donut",
                              {
                                attrs: {
                                  sections: !_vm.course.is_open
                                    ? _vm.sections
                                    : [],
                                  size: 100,
                                  unit: "%"
                                }
                              },
                              [
                                _vm.user_progress <= 99 &&
                                _vm.presential_event_user_result_status != 1 &&
                                _vm.presential_event_user_result_status != 2 &&
                                !_vm.course.is_open
                                  ? _c("h6", { staticClass: "text-primary" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getPercentage(_vm.user_progress)
                                          ) +
                                          "%\n                            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.user_progress >= 100 ||
                                _vm.presential_event_user_result_status == 1 ||
                                (_vm.presential_event_user_result_status == 2 &&
                                  !_vm.course.is_open)
                                  ? _c("q-icon", {
                                      attrs: {
                                        name: _vm.getResult,
                                        color: _vm.getResultColor,
                                        size: "2rem"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.course.is_open
                                  ? _c(
                                      "q-icon",
                                      {
                                        attrs: {
                                          name: "fal fa-clock",
                                          color: "primary",
                                          size: "2rem"
                                        }
                                      },
                                      [
                                        _c("q-tooltip", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "this_course_is_being_published_your_progress_will_show_when_its_finished"
                                                )
                                              ) +
                                              "\n                                "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.presential_event_user_result_status == 2
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("you_were_reproved_in") +
                                              " " +
                                              _vm.presential_event_user_result_date
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm.$q.platform.is.mobile
                    ? _c("div", { staticClass: "row gutter-xs" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-10" },
                          [
                            _c("p", { staticClass: "q-title" }, [
                              _vm._v(_vm._s(_vm.title))
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-11" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "q-body-1 text-weight-light" },
                                  [_vm._v(_vm._s(_vm.description))]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "q-my-xs text-weight-bold" },
                                  [_vm._v(_vm._s(_vm.$t("instructors")))]
                                ),
                                _vm._l(_vm.instructors_list, function(
                                  instructor,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "q-my-sm" },
                                    [
                                      _c("p", { staticClass: "q-my-xs" }, [
                                        _vm._v(_vm._s(instructor))
                                      ])
                                    ]
                                  )
                                })
                              ],
                              2
                            ),
                            _c("q-btn", {
                              staticClass: "order-last",
                              attrs: {
                                color: _vm.getSubscribeButtonColor,
                                label: _vm.$t(_vm.getSubscribeButtonLabel),
                                icon: _vm.getSubscribeButtonIcon
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showSubscription()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-2",
                            on: {
                              click: function($event) {
                                return _vm.showCertificate()
                              }
                            }
                          },
                          [
                            _c(
                              "vc-donut",
                              {
                                attrs: {
                                  sections: !_vm.course.is_open
                                    ? _vm.sections
                                    : [],
                                  size: 100,
                                  unit: "%"
                                }
                              },
                              [
                                _vm.user_progress <= 99 &&
                                _vm.presential_event_user_result_status != 1 &&
                                _vm.presential_event_user_result_status != 2 &&
                                !_vm.course.is_open
                                  ? _c("h6", { staticClass: "text-primary" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.getPercentage(_vm.user_progress)
                                          ) +
                                          "%\n                            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.user_progress >= 100 ||
                                _vm.presential_event_user_result_status == 1 ||
                                (_vm.presential_event_user_result_status == 2 &&
                                  !_vm.course.is_open)
                                  ? _c("q-icon", {
                                      attrs: {
                                        name: _vm.getResult,
                                        color: _vm.getResultColor,
                                        size: "1.7rem"
                                      }
                                    })
                                  : _vm._e(),
                                _vm.presential_event_user_result_status == 2
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("you_were_reproved_in") +
                                              " " +
                                              _vm.presential_event_user_result_date
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "row reverse gutter-sm q-mt-sm" }, [
                    _vm.$route.name == "view_presential"
                      ? _c(
                          "div",
                          {
                            class: _vm.$q.platform.is.ipad
                              ? "col-4"
                              : "col-xs-12 col-sm-2"
                          },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                label: _vm.$t("back"),
                                color: "primary",
                                icon: "far fa-chevron-left"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "presential"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$route.name == "trail_course"
                      ? _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-2" },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                label: _vm.$t("back"),
                                color: "primary",
                                icon: "far fa-chevron-left"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "trail",
                                    params: { id: _vm.$route.params.id_trail }
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "q-tabs",
                    {
                      staticClass: "q-mt-md",
                      attrs: {
                        color: "secondary",
                        "underline-color": "primary",
                        align: "justify"
                      },
                      model: {
                        value: _vm.tab_course,
                        callback: function($$v) {
                          _vm.tab_course = $$v
                        },
                        expression: "tab_course"
                      }
                    },
                    [
                      _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "activities",
                          label: _vm.$q.platform.is.desktop
                            ? _vm.$t("activities") +
                              " (" +
                              _vm.qty_presential_activities +
                              ")"
                            : "(" + _vm.qty_presential_activities + ")",
                          icon: "fal fa-pen"
                        },
                        slot: "title"
                      }),
                      _vm.user_subscribed
                        ? _c("q-tab", {
                            attrs: {
                              slot: "title",
                              name: "support_materials",
                              label: _vm.$q.platform.is.desktop
                                ? _vm.$t("support_materials") +
                                  " (" +
                                  _vm.qty_presential_materials +
                                  ")"
                                : "(" + _vm.qty_presential_materials + ")",
                              icon: "fal fa-books"
                            },
                            slot: "title"
                          })
                        : _vm._e(),
                      _vm.user_subscribed
                        ? _c("q-tab", {
                            attrs: {
                              slot: "title",
                              name: "reaction_test",
                              label: _vm.$q.platform.is.desktop
                                ? _vm.$t("reaction_test") +
                                  " (" +
                                  _vm.qty_presential_evaluations +
                                  ")"
                                : "(" + _vm.qty_presential_evaluations + ")",
                              icon: "fal fa-clipboard-list-check"
                            },
                            slot: "title"
                          })
                        : _vm._e(),
                      _c(
                        "q-tab-pane",
                        {
                          staticStyle: { padding: "5px 1px" },
                          attrs: { name: "activities" }
                        },
                        [
                          _c("activities", {
                            attrs: {
                              address: _vm.address,
                              course: _vm.course,
                              user_subscribed: _vm.user_subscribed
                            },
                            on: { reloadActivity: _vm.reloadActivity }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-xl q-mt-md",
                          attrs: { name: "support_materials" }
                        },
                        [_c("support-materials")],
                        1
                      ),
                      _c(
                        "q-tab-pane",
                        {
                          staticClass: "q-px-md q-pb-xl q-mt-md",
                          attrs: { name: "reaction_test" }
                        },
                        [
                          _c("reaction-test", {
                            on: { reloadActivity: _vm.reloadActivity }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        return _vm.hideCourseInfo()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: _vm.user_subscribed ? "negative" : "positive",
                      label: _vm.user_subscribed
                        ? _vm.$t("unsubscribe")
                        : _vm.$t("subscribe")
                    },
                    on: { click: _vm.toggleSubscription }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_subscribe_presential,
            callback: function($$v) {
              _vm.confirm_subscribe_presential = $$v
            },
            expression: "confirm_subscribe_presential"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(
              _vm._s(
                _vm.user_subscribed
                  ? _vm.$t("unsubscribe")
                  : _vm.$t("subscribe")
              )
            )
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.user_subscribed
                    ? _vm.$t("unsubscribe_confirmation")
                    : _vm.$t("subscribe_confirmation")
                ) +
                "\n        "
            )
          ]),
          !_vm.user_subscribed
            ? _c(
                "span",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "q-field",
                    [
                      _c("q-checkbox", {
                        attrs: {
                          label: _vm.$t("receive_emails_about_this_training")
                        },
                        model: {
                          value: _vm.check_emails_presential,
                          callback: function($$v) {
                            _vm.check_emails_presential = $$v
                          },
                          expression: "check_emails_presential"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c("certificate", {
        attrs: {
          show: _vm.show_certificate,
          data: _vm.certificate_data,
          certificate: _vm.certificate
        },
        on: { hideCertificate: _vm.hideCertificate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }